<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/FMeYqn/tc-custom/9783989735330.jpg?1735586451593" alt="This image is the cover for the book The Moving Finger, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Moving Finger, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>In 'The Moving Finger' by Natalie Sumner Lincoln, a mysterious letter arrives in a quiet town, sparking a chain of events that unravels the hidden secrets and tangled relationships of its residents, where every character is a suspect and no one is safe from the prying eyes of suspicion. As the enigmatic message spreads its influence, the protagonist must navigate a labyrinth of deceit, betrayal, and unexpected alliances, all while racing against time to uncover the truth before the past's shadows consume the present. This gripping tale weaves a tapestry of intrigue and suspense, exploring themes of justice, morality, and the consequences of hidden truths, resonating with contemporary society's fascination with the blurred lines between right and wrong. Lincoln's masterful storytelling invites readers into a world where the past and present collide, challenging perceptions and leaving them questioning the very nature of truth and trust. Prepare to be captivated by a narrative that keeps you on the edge of your seat, as each page turns with the promise of revelation and the threat of danger, echoing the timeless relevance of human nature's complexities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Natalie Sumner Lincoln
      </h2>
      
      <p class="authorDescription body article">Natalie Sumner Lincoln (1881-1935) was an American author renowned for her contributions to early 20th-century detective fiction. Born into a prominent Washington, D.C. family, Lincoln was well-educated and deeply embedded in the political and social circles of the capital, which often served as the backdrop for her intricate mystery novels. Her works are characterized by their keen attention to detail, complex plots, and strong, intelligent female protagonists, which were quite revolutionary for her time.<br>Lincoln's writing career flourished during an era when detective fiction was gaining popularity, and she quickly became a contemporary of other notable mystery writers like Mary Roberts Rinehart. Her ability to weave suspense with social commentary set her apart, making her a significant figure in the genre's development. <br>One of the intriguing aspects of Lincoln's life was her involvement in the suffrage movement, advocating for women's rights and using her platform to address social injustices. This activism not only influenced her writing but also resonated with many readers who found her characters' independence and resilience inspiring.<br>Despite her success, Lincoln's life was not without controversy. Her outspoken political views and critiques of societal norms sometimes put her at odds with the conservative elements of her social circle. Nevertheless, her legacy endures, as she paved the way for future generations of female writers in the mystery and detective genres. Natalie Sumner Lincoln remains a fascinating figure whose work continues to captivate and inspire readers and writers alike.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?a75cea62